/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import hexColors from '../../../assets/images/hex-colors.png'
import alfa from '../../../assets/images/alfa.jpg'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Работа с цветом</h2>
    <p className={styles.description}>
      Цвет оказывает огромное эмоциональное влияние на человека, поэтому неудивительно, что маркетологи и дизайнеры
      разрабатывают различные цветовые схемы оформления сайта. Этот раздел поможет разобраться с возможностями браузера
      по отображению цвета - как можно описать цвет с помощью символов, какие модели для описания существуют и как можно
      описать отсутствие цвета - прозрачность.{' '}
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.2 - RGB</h3>
      <p className={styles.description}>Основные цвета - RED, GREEN, BLUE</p>
      <p className={styles.description}>Допустимые диапазоны:</p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <b>0% - 100%</b> процентный{' '}
        </li>
        <li className={styles.list__item}>
          <b>0 - 255</b> числовой (один байт)
        </li>
      </ul>
      <p className={styles.description}>Синтаксис:</p>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Тип</th>
            <th>Описание</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>процентный</td>
            <td>rgb(0%, 50%, 100%);</td>
          </tr>
          <tr>
            <td>числовой</td>
            <td>rgb(0, 127, 255);</td>
          </tr>
        </tbody>
      </table>
      <iframe
        scrolling="no"
        title="color-rgb-255"
        src="https://codepen.io/GoIT-fe/embed/dzVbGx?default-tab=html%2Cresult"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.3 - Hexadecimal</h3>
      <p className={styles.description}>
        Это описание цвета основано на 16-ричной записи числа. Для тех, кто не знаком с этой нотацией, необходимо
        предварительно ознакомиться с{' '}
        <a
          className={styles.link}
          href="https://ru.wikipedia.org/wiki/%D0%A8%D0%B5%D1%81%D1%82%D0%BD%D0%B0%D0%B4%D1%86%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D1%87%D0%BD%D0%B0%D1%8F_%D1%81%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0_%D1%81%D1%87%D0%B8%D1%81%D0%BB%D0%B5%D0%BD%D0%B8%D1%8F"
          target="_blank"
          rel="noopener noreferrer"
        >
          Шестнадцатеричной системой счисления{' '}
        </a>
        .
      </p>
      <p className={styles.description}>Основные цвета - RED, GREEN, BLUE </p>
      <p className={styles.description}>Допустимые диапазоны:</p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <code className={styles.code}>0</code> - <code className={styles.code}>f</code> числовой, 16-ричный (краткая
          нотация){' '}
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>00</code> - <code className={styles.code}>ff</code> числовой, 16-ричный (полная
          нотация)
        </li>
      </ul>
      <p className={styles.description}>
        16-ричный формат содержит символы: 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, a, b, c, d, e, f или 0, 1, 2, 3, 4, 5, 6, 7, 8,
        9, A, B, C, D, E, F
      </p>
      <p className={styles.description}>Синтаксис:</p>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Тип</th>
            <th>Описание</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>краткий</td>
            <td>#f60;</td>
          </tr>
          <tr>
            <td>полный</td>
            <td>#ff6600;</td>
          </tr>
        </tbody>
      </table>
      <img className={styles.img} src={hexColors} alt="Hex-colors" />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.5 - Прозрачность (alpha channel)</h3>
      <p className={styles.description}>
        <code className={styles.code}>A</code> задает уровень непрозрачности для цветовых схем RGB и HSL -{' '}
        <code className={styles.code}>RGBA</code> и <code className={styles.code}>HSLA</code>.
      </p>
      <p className={styles.description}>
        Допустимые диапазоны: дробные числа между <code className={styles.code}>0</code> и{' '}
        <code className={styles.code}>1</code>
      </p>
      <img className={styles.img} src={alfa} alt="alfa" />
    </section>
  </section>
))
